import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8.18359 6.1333H5.80469V10.9702H8.18359V6.1333ZM10.1836 12.9702H5.80469C4.70012 12.9702 3.80469 12.0748 3.80469 10.9702V6.1333C3.80469 5.02873 4.70012 4.1333 5.80469 4.1333H8.18359C9.28799 4.13351 10.1836 5.02886 10.1836 6.1333V12.9702Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8.18262 10.9705V2.92848C8.18262 1.61441 9.42855 0.657264 10.6982 0.995867L14.7119 2.06618C15.5874 2.29965 16.1963 3.09272 16.1963 3.9988V10.9705C16.1963 12.075 15.3009 12.9705 14.1963 12.9705H10.1826C9.07805 12.9705 8.18262 12.075 8.18262 10.9705ZM10.1826 10.9705H14.1963V3.9988L10.1826 2.92848V10.9705Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M11.0527 4.99867C11.0527 4.55796 11.41 4.20068 11.8507 4.20068H12.529C12.9697 4.20068 13.327 4.55796 13.327 4.99867C13.327 5.43939 12.9697 5.79666 12.529 5.79666H11.8507C11.41 5.79666 11.0527 5.43939 11.0527 4.99867Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M11.0527 7.32533C11.0527 6.88462 11.41 6.52734 11.8507 6.52734H12.529C12.9697 6.52734 13.327 6.88462 13.327 7.32533C13.327 7.76605 12.9697 8.12332 12.529 8.12332H11.8507C11.41 8.12332 11.0527 7.76605 11.0527 7.32533Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M11.0527 9.65175C11.0527 9.21103 11.41 8.85376 11.8507 8.85376H12.529C12.9697 8.85376 13.327 9.21103 13.327 9.65175C13.327 10.0925 12.9697 10.4497 12.529 10.4497H11.8507C11.41 10.4497 11.0527 10.0925 11.0527 9.65175Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  d: "M6.77734 16.4514C6.62543 16.4514 6.47778 16.4767 6.3457 16.5217C6.21308 16.567 6.10268 16.6291 6.01856 16.6985C5.99329 16.7193 5.97317 16.7429 5.95313 16.7639H14.0479C14.0279 16.743 14.0076 16.7192 13.9824 16.6985C13.8983 16.6292 13.7888 16.566 13.6563 16.5208C13.5236 16.4755 13.3763 16.4513 13.2246 16.4514H6.77734ZM16.1963 17.3557C16.1962 17.798 15.9815 18.1727 15.6875 18.4153C15.3989 18.6534 15.042 18.7639 14.7012 18.7639H5.30078C4.95991 18.7639 4.60314 18.6534 4.31445 18.4153C4.02042 18.1727 3.80571 17.7981 3.80566 17.3557V17.0784C3.80535 16.7037 3.89523 16.3388 4.06152 16.0071C4.22744 15.6762 4.4639 15.3894 4.74609 15.1565C5.02811 14.9238 5.35334 14.7473 5.69922 14.6292C6.04558 14.5109 6.41244 14.4513 6.77832 14.4514H13.2236V14.4524C13.5899 14.4521 13.9558 14.5102 14.3018 14.6282C14.6476 14.7462 14.9728 14.923 15.2549 15.1555C15.5373 15.3885 15.7744 15.676 15.9404 16.0071C16.1068 16.3389 16.1966 16.7036 16.1963 17.0784V17.3557Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("path", {
  d: "M3.0306 13.1638V10.6687C3.0306 10.1164 2.58288 9.6687 2.0306 9.6687C1.47831 9.6687 1.0306 10.1164 1.0306 10.6687V13.1638C1.0306 14.6409 1.63467 15.6618 2.49446 16.2673C3.29803 16.8331 4.22973 16.972 4.86067 16.9363C5.41204 16.905 5.83331 16.432 5.80208 15.8806C5.77062 15.3294 5.29865 14.908 4.74739 14.9392C4.45388 14.9558 3.99879 14.8794 3.64681 14.6316C3.35117 14.4234 3.0306 14.0309 3.0306 13.1638Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("path", {
  d: "M16.9704 13.1638V10.6687C16.9704 10.1164 17.4181 9.6687 17.9704 9.6687C18.5227 9.6687 18.9704 10.1164 18.9704 10.6687V13.1638C18.9704 14.6409 18.3663 15.6618 17.5065 16.2673C16.7029 16.8331 15.7712 16.972 15.1403 16.9363C14.5889 16.905 14.1677 16.432 14.1989 15.8806C14.2304 15.3294 14.7023 14.908 15.2536 14.9392C15.5471 14.9558 16.0022 14.8794 16.3542 14.6316C16.6498 14.4234 16.9704 14.0309 16.9704 13.1638Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9
  ]))
}